module.exports = __webpack_public_path__ + "static/media/timeline_back.22946081.svg";